export default {
	header:         null,
	listOfStatuses: [],
	load:           false,
	href:           '',
	message:		      null
};
